<template>
  <slot :memoryState="memoryState"></slot>
</template>

<script>
import { useMemoryState } from '../composables/ShowOnDemandByScrollMemory.js'
export default {
  inheritAttrs: false,
  setup() {
    const { memoryState } = useMemoryState()

    return {
      memoryState
    }
  }
}
</script>
